<template lang='pug'>
//- Profile-Detail
div(:class='$style[`cc-detail-board`]')

  div(v-if='isLoading' :class='$style[`cc-loading-data`]')
    IconLoading(:size='28' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-detail-content`]')
    div(v-show='rwdType === `mobile`' :class='$style[`cc-detail-board-type`]')
      span.font-medium!= '會員檔案'

    div(:class='$style[`cc-detail-board-wrap`]')
      div(:class='$style[`cc-detail-status-hp`]')
        IconHp(:size='48')
        span.font-medium {{ `${profileData.hp}` }}
          span(:class='$style[`cc-detail-status-hp-tips`]')!= '經驗值'

      ul(:class='$style[`cc-detail-status`]')

        li(:class='$style[`cc-status-nav`]')
          span.font-medium(:class='[type === `doctor` ? `font-doctor-theme` : `font-normal-theme`, $style[`cc-status-nav-value`]]') {{ `${id}` }}
          span(:class='$style[`cc-status-nav-info`]') {{ '會員編號' }}

        li(:class='$style[`cc-status-nav`]')
          span.font-medium(:class='[type === `doctor` ? `font-doctor-theme` : `font-normal-theme`, $style[`cc-status-nav-value`]]') {{ totalBookmark }}
          span(:class='$style[`cc-status-nav-info`]') {{ '個收藏數' }}

        li(v-if='type === `doctor`' :class='$style[`cc-status-nav`]')
          span.font-medium.font-doctor-theme(:class='$style[`cc-status-nav-value`]') {{ profileData.follower.length }}
          span(:class='$style[`cc-status-nav-info`]') {{ '人追蹤中' }}

        li(v-if='type === `normal`' :class='$style[`cc-status-nav`]')
          span.font-medium.font-normal-theme(:class='$style[`cc-status-nav-value`]') {{ profileData.following.length }}
          span(:class='$style[`cc-status-nav-info`]') {{ '位追蹤的醫師' }}

        li(v-if='type === `doctor` && profileData.character' :class='$style[`cc-status-nav`]')
          span.font-medium.font-doctor-theme(:class='$style[`cc-status-nav-value`]') {{ profileData.character }}
          span(:class='$style[`cc-status-nav-info`]') {{ '醫療身份' }}


      ul(v-if='type === `doctor`' :class='$style[`cc-detail-describe`]')
        li(v-if='profileData.hospital' :class='$style[`cc-describe-nav`]')
          //- IconGuild(:size='18' :color='`#b1b1b1`')
          span {{ profileData.hospital }}

        li(v-if='profileData.profession' :class='$style[`cc-describe-nav`]')
          //- IconGuild(:size='18' :color='`#b1b1b1`')
          span {{ profileData.profession }}

        a(v-if='profileData.introduction' :href='profileData.introduction' target='_blank' rel='noreferrer' :class='$style[`cc-describe-nav`]')
          span {{ '個人網站' }}
          IconLink(:size='16' :color='`#b1b1b1`')

    div(:class='$style[`cc-detail-share`]')
      div(:class='$style[`cc-share-link`]')
        div(:class='$style[`cc-share-link-wrap`]')
          span!= '分享網址：'
          span(:class='$style[`cc-share-link-path`]') {{ `https://cancell.tw/${type}/${id}` }}

          //- 複製會員連結
          span(:class='$style[`cc-share-link-copy`]' @click='copyUserLink')
            transition(name='animate-slide-up-fade')
              div(
                v-if='showCopyTips'
                :class='$style[`cc-link-copy-tip`]')
                span {{ showCopyMsg }}
            span(:class='$style[`cc-share-link-text`]')!= '複製連結'

      div(:class='$style[`cc-share-qrcode`]')
        div(:class='$style[`cc-share-qrcode-wrap`]')
          img(:src='`${SERVER_DOMAIN}/apiserver/qrcode/?url=https://cancell.tw/${type}/${id}`' width='100%' height='100%')
          a(
            download
            target='_blank'
            :href='`${SERVER_DOMAIN}/apiserver/qrcode/?url=https://cancell.tw/${type}/${id}.jpg`'
            :class='$style[`cc-share-qrcode-download`]')!= '下載圖檔'


</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

import {
  getNormalData,
  getDoctorData,
  // getLoadAllBookmark,
} from '../../../js/restapi';

import IconGuild from '../../icon/Guild';
import IconLoading from '../../icon/Loading';
import IconLink from '../../icon/Link';
import IconHp from '../../icon/Hp';

export default {
  metaInfo() {
    return {
      title: this.type === 'doctor' ? `醫護${this.id}的檔案` : `會員${this.id}的檔案`,
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/${this.type}/${this.id}`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/${this.type}/${this.id}`,
      }],
    };
  },

  components: {
    IconGuild,
    IconLoading,
    IconLink,
    IconHp,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: true,
      showCopyTips: true,
      showCopyMsg: '',
      totalBookmark: 0,
      profileData: {},
    };
  },

  created() {
    this.handleRouterTypeOnLoad(this.type, this.id);
  },

  methods: {
    handleRouterTypeOnLoad(userType, id) {
      switch (userType) {
        case 'doctor':

          getDoctorData(`/?pk=${id}`)
            .then((res) => {
              this.profileData = res.data;
              // this.totalBookmark = bookmarkCount.data;
              this.isLoading = false;
              // console.log(this.profileData);
            })
            .catch((error) => console.log('handleRouterTypeOnLoad Error: ', error.response));

          // axios.all([
          //   getDoctorData(`/?pk=${id}`),
          //   getLoadAllBookmark('', {
          //     user_id: `${id}`,
          //     size: '1',
          //     page: '1',
          //     showcount: '1',
          //   }),
          // ])
          //   .then(axios.spread((profile, bookmarkCount) => {
          //     this.profileData = profile.data;
          //     this.totalBookmark = bookmarkCount.data;
          //     this.isLoading = false;
          //     // console.log(this.profileData);
          //   }))
          //   .catch((error) => console.log('handleRouterTypeOnLoad Error: ', error.response));
          break;

        case 'normal':
          getNormalData(`/?pk=${id}`)
            .then((res) => {
              this.profileData = res.data;
              this.isLoading = false;
              // console.log(this.profileData);
            })
            .catch((error) => console.log('handleRouterTypeOnLoad Error: ', error.response));

          // axios.all([
          //   getNormalData(`/?pk=${id}`),
          //   getLoadAllBookmark('', {
          //     user_id: `${id}`,
          //     size: '1',
          //     page: '1',
          //     showcount: '1',
          //   }),
          // ])
          //   .then(axios.spread((profile, bookmarkCount) => {
          //     this.profileData = profile.data;
          //     this.totalBookmark = bookmarkCount.data;
          //     this.isLoading = false;
          //     // console.log(this.profileData);
          //   }))
          //   .catch((error) => console.log('handleRouterTypeOnLoad Error: ', error.response));
          break;

        default:
          break;
      }
    },

    copyUserLink() {
      this.showCopyTips = false;
      this.showCopyMsg = '已複製';

      this.$copyText(`https://cancell.tw/${this.type}/${this.id}`)
        .then((e) => {
          this.showCopyTips = true;
        }, (e) => {
          this.showCopyMsg = '複製失敗';
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/profileDetail.scss';
</style>
